import { UI, HStack, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

interface SubscriptionInfoProps {
  label: string;
  value: string;
  isMobile?: boolean;
}

export const SubscriptionInfo: React.FC<SubscriptionInfoProps> = ({ label, value, isMobile }) => {
  if (isMobile) {
    return (
      <HStack space="inline.nano" justifyContent="space-between">
        <UI.Text color="neutral.darkest" variant="semibold">
          {label}
        </UI.Text>
        <UI.Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.xs']}>
          {value}
        </UI.Text>
      </HStack>
    );
  }

  return (
    <VStack space="stack.quarck">
      <UI.Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.xs']}>
        {label}
      </UI.Text>
      <UI.Text color="neutral.darkest" variant="semibold">
        {value}
      </UI.Text>
    </VStack>
  );
};
